WiseMetering.Collection.Contracts = WiseMetering.Collection.extend({
    hasOrganization: true,
    model: WiseMetering.Model.Contract,
    url: '/contracts',
    comparator: 'start'
});
